// test1219
(1219 && 0);
